<template>
  <div>
    <h4 class="text-xl uppercase mb-1" v-bind="$attrs"><slot /></h4>
  </div>
</template>
